import React, { useEffect, useState } from "react";
import { Card, Typography, IconButton, TextField } from "@mhome/ui";
import CloseIcon from "@mui/icons-material/Close";

import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";

const IntegrationsFilter = ({
  sortBy,
  setSortBy,
  setFilterText,
  setShowFilter,
}) => {
  const [searchInput, setSearchInput] = useState("");

  // Get the background color function with current global state
  const getComponentBgColor = useComponentBackgroundColor();

  useEffect(() => {
    setFilterText(searchInput);
  });

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // pass
    }
  };

  const handleClose = () => {
    setSearchInput("");
    setShowFilter(false);
  };

  const handleClear = () => {
    setSearchInput("");
    setFilterText("");
  };

  return (
    <Card
      elevation={0}
      className="mb-6 w-full"
      style={{
        backgroundColor: getComponentBgColor("hsl(var(--card))"),
      }}
    >
      <div className="flex flex-col p-2 w-full gap-6">
        <div className="w-full">
          <Typography
            variant="caption"
            color="textSecondary"
            className="font-medium mb-1 block"
          >
            Name
          </Typography>
          <TextField
            fullWidth
            value={searchInput}
            onChange={handleSearchInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Filter by name"
            variant="outlined"
            size="small"
            InputProps={{
              endAdornment: searchInput && (
                <IconButton
                  size="small"
                  onClick={handleClear}
                  className="-mr-1"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default IntegrationsFilter;
